export enum Locales {
    ES = 'es',
  }
  
  export const LOCALES = [
    { value: Locales.ES, caption: 'Español' }
  ]